export default {
  'login.title': 'MyStorageX',
  'login.welcome': 'Bienvenue sur MyStorageX',
  'login.description': 'MyStorageX est votre assistant de stockage cloud, offrant un stockage et une gestion de fichiers sûrs et pratiques. Accédez à vos fichiers n\'importe quand, n\'importe où.',
  'login.email.placeholder': 'Email ou nom d\'utilisateur',
  'login.password.placeholder': 'Mot de passe',
  'login.button': 'Connexion',
  'login.loading': 'Connexion en cours...',
  'login.divider': 'ou',
  'login.signup': 'Pas encore de compte ?',
  'login.signup.link': 'S\'inscrire',
  'login.error.default': 'Échec de la connexion, veuillez réessayer plus tard',
  'login.success': 'Connexion réussie',
  'login.forgotPassword': 'Mot de passe oublié ?',
  'login.forgotPassword.link': 'Réinitialiser ici',
  'signup.title': 'MyStorageX',
  'signup.welcome': 'Bienvenue sur MyStorageX',
  'signup.description': 'Créez votre compte et commencez votre voyage de stockage cloud',
  'signup.username.placeholder': 'Entrez le nom d\'utilisateur',
  'signup.email.placeholder': 'Entrez l\'email',
  'signup.password.placeholder': 'Entrez le mot de passe',
  'signup.confirmPassword.placeholder': 'Confirmez le mot de passe',
  'signup.button': 'S\'inscrire',
  'signup.loading': 'Inscription en cours...',
  'signup.login': 'Déjà un compte ?',
  'signup.login.link': 'Se connecter',
  'signup.error.passwordMismatch': 'Les mots de passe ne correspondent pas',
  'signup.error.default': 'Échec de l\'inscription, veuillez réessayer plus tard',
  'signup.success': 'Inscription réussie',
  'signup.username.rule.length': 'Le nom d\'utilisateur doit contenir entre 4 et 10 caractères',
  'signup.username.rule.format': 'Seuls les lettres, chiffres, tirets bas et traits d\'union sont autorisés',
  'signup.password.rule.length': 'Le mot de passe doit contenir entre 6 et 20 caractères',
  'signup.password.rule.lowercase': 'Doit contenir des lettres minuscules',
  'signup.password.rule.uppercase': 'Doit contenir des lettres majuscules',
  'signup.password.rule.number': 'Doit contenir des chiffres',
  'signup.password.rule.special': 'Doit contenir des caractères spéciaux',
  'resetPassword.page.title': 'Réinitialisation du mot de passe - MyStorageX',
  'resetPassword.page.description': 'Réinitialisez votre mot de passe MyStorageX',
  'resetPassword.title': 'Réinitialiser le mot de passe',
  'resetPassword.email.placeholder': 'Entrez votre adresse e-mail',
  'resetPassword.code.placeholder': 'Entrez le code de vérification',
  'resetPassword.password.placeholder': 'Entrez le nouveau mot de passe',
  'resetPassword.button': 'Réinitialiser',
  'resetPassword.button.loading': 'Réinitialisation...',
  'resetPassword.backToLogin': 'Retour à la connexion',
  'resetPassword.sendCode': 'Obtenir le code',
  'resetPassword.sendCode.sending': 'Envoi...',
  'resetPassword.sendCode.retry': 'Réessayer dans {seconds}s',
  'resetPassword.error.emailRequired': 'Veuillez entrer votre adresse e-mail',
  'resetPassword.error.codeRequired': 'Veuillez entrer le code de vérification',
  'resetPassword.error.passwordRequired': 'Veuillez entrer le nouveau mot de passe',
  'resetPassword.error.passwordLength': 'Le mot de passe doit contenir entre 6 et 20 caractères',
  'resetPassword.error.codeLength': 'Le code de vérification doit contenir 6 chiffres',
  'resetPassword.success.codeSent': 'Le code de vérification a été envoyé à votre e-mail',
  'resetPassword.success.reset': 'Mot de passe réinitialisé avec succès',
  'resetPassword.error.sendFailed': 'Échec de l\'envoi du code de vérification, veuillez réessayer plus tard',
  'resetPassword.error.resetFailed': 'Échec de la réinitialisation du mot de passe, veuillez réessayer plus tard',
  'signup.verificationCode.placeholder': 'Entrez le code de vérification',
  'signup.verificationCode.send': 'Obtenir le code',
  'signup.verificationCode.sending': 'Envoi en cours...',
  'signup.verificationCode.retry': 'Réessayer dans {seconds}s',
  'signup.verificationCode.success': 'Code de vérification envoyé',
  'signup.verificationCode.error': 'Échec de l\'envoi du code',
  'signup.verificationCode.required': 'Veuillez entrer le code de vérification',
  'signup.verificationCode.invalid': 'Format de code de vérification invalide',
  'signup.error.emailRequired': 'Veuillez saisir votre adresse e-mail',
  'signup.announcement': 'La fonction d\'inscription est en maintenance aujourd\'hui !',
  'sidebar.allFiles': 'Tous les fichiers',
  'sidebar.starred': 'Favoris',
  'sidebar.folders': 'Dossiers',
  'sidebar.trash': 'Corbeille',
  'sidebar.decrypt': 'Outil de déchiffrement',
  'sidebar.feedback': 'Retour',
  'sidebar.about': 'À propos',
  'sidebar.productLog': 'Mises à jour',
  'filelist.column.name': 'Nom',
  'filelist.column.size': 'Taille',
  'filelist.column.updateTime': 'Modifié',
  'filelist.column.recycletime': 'Date de suppression',
  'filelist.column.actions': 'Actions',
  'filelist.total': 'Total {total} éléments',
  'filelist.action.upload': 'Téléverser',
  'filelist.action.newFolder': 'Nouveau dossier',
  'filelist.action.refresh': 'Actualiser',
  'filelist.action.search': 'Rechercher des fichiers',
  'filelist.action.batchDownload': 'Télécharger',
  'filelist.action.batchDelete': 'Supprimer',
  'filelist.action.download': 'Télécharger',
  'filelist.action.preview': 'Aperçu',
  'filelist.action.rename': 'Renommer',
  'filelist.selected': '{count} sélectionné(s)',
  'page.cloudDrive.title': 'Mon Cloud Drive',
  'page.cloudDrive.description': 'MyStorageX Cloud Drive - Stockez et gérez vos fichiers en toute sécurité',
  'modal.fileUpload.title': 'Téléverser des fichiers',
  'modal.fileUpload.dragText': 'Glissez les fichiers ici ou cliquez pour téléverser',
  'modal.fileUpload.start': 'Démarrer le téléversement',
  'modal.fileUpload.cancel': 'Annuler',
  'modal.fileUpload.clear': 'Vider la liste',
  'modal.fileUpload.encrypt': 'Chiffrer la sélection',
  'modal.fileUpload.addMore': 'Ajouter',
  'modal.fileUpload.remove': 'Retirer',
  'modal.fileUpload.error.noSelection': 'Veuillez sélectionner des fichiers à retirer',
  'modal.fileUpload.error.noEncryption': 'Veuillez sélectionner des fichiers à chiffrer',
  'modal.fileUpload.error.noClear': 'Aucun fichier à effacer',
  'modal.fileUpload.error.noStart': 'Aucun fichier à téléverser',
  'modal.fileUpload.error.noCancel': 'Aucun téléversement en cours à annuler',
  'modal.fileUpload.error.fileSize': 'Taille de fichier dépassée',
  'modal.fileUpload.error.fileType': 'Type de fichier non pris en charge',
  'modal.fileUpload.error.maxCount': 'Nombre maximum de fichiers dépassé',
  'modal.fileUpload.duplicate.title': 'Le fichier existe déjà',
  'modal.fileUpload.duplicate.skip': 'Ignorer',
  'modal.fileUpload.duplicate.replace': 'Remplacer',
  'modal.fileUpload.duplicate.rename': 'Renommer',
  'modal.fileUpload.status.pending': 'En attente',
  'modal.fileUpload.status.uploading': 'Téléversement en cours',
  'modal.fileUpload.status.success': 'Terminé',
  'modal.fileUpload.status.error': 'Erreur',
  'modal.fileUpload.status.cancelled': 'Annulé',
  'modal.fileUpload.status.duplicated': 'Dupliqué',
  'modal.fileUpload.table.filename': 'Nom du fichier',
  'modal.fileUpload.table.size': 'Taille',
  'modal.fileUpload.table.status': 'État',
  'modal.fileUpload.table.progress': 'Progression',
  'modal.fileUpload.table.actions': 'Actions',
  'modal.fileUpload.speed': 'Vitesse de téléversement',
  'modal.fileUpload.remainingTime': 'Temps restant',
  'modal.fileUpload.total.progress': 'Progression totale',
  'modal.fileUpload.error.message': 'Échec du téléversement : {message}',
  'modal.fileUpload.confirm.clear': 'Voulez-vous vider la liste de téléversement ?',
  'modal.fileUpload.confirm.cancel': 'Voulez-vous annuler le téléversement ?',
  'modal.fileUpload.clear.mobile': 'Vider',
  'modal.fileUpload.encrypt.mobile': 'Chiffrer',
  'modal.fileUpload.addMore.mobile': 'Ajouter',
  'productLog.title': 'Mises à jour du produit',
  'signup.page.title': 'Inscription - MyStorageX',
  'security.features.title': 'Fonctionnalités de sécurité',
  'security.features.localDecryption.title': 'Déchiffrement local',
  'security.features.localDecryption.description': 'Toutes les opérations de déchiffrement sont effectuées localement dans votre navigateur, le contenu du fichier et le mot de passe ne quittent jamais votre appareil',
  'security.features.militaryEncryption.title': 'Chiffrement militaire',
  'security.features.militaryEncryption.description': 'Utilise l\'algorithme de chiffrement AES-256-CBC, la norme de chiffrement symétrique la plus sûre qui peut résister à toutes les attaques connues',
  'security.features.privacyProtection.title': 'Protection de la vie privée',
  'security.features.privacyProtection.description': 'Mécanisme strict de protection de la vie privée, aucun mot de passe de déchiffrement n\'est sauvegardé, aucun contenu de fichier n\'est enregistré',
  'security.features.smartDecryption.title': 'Déchiffrement intelligent par blocs',
  'security.features.smartDecryption.description': 'La technologie de déchiffrement intelligent par blocs améliore significativement la vitesse de déchiffrement tout en réduisant l\'utilisation de la mémoire',
  'security.features.learnMore': 'En savoir plus',
  'security.features.modal.title': 'Détails des fonctionnalités de sécurité',
  'security.features.modal.close': 'Fermer',
  'decrypt.security.modal.title': 'Avis de sécurité',
  'decrypt.security.modal.description': 'Toutes les opérations de déchiffrement sont effectuées localement, votre mot de passe et le contenu du fichier ne seront jamais envoyés au serveur',
  'decrypt.security.modal.vip.title': 'En tant qu\'utilisateur VIP, vous pouvez :',
  'decrypt.security.modal.vip.feature1': 'Déchiffrer des fichiers de toute taille',
  'decrypt.security.modal.vip.feature2': 'Utiliser le déchiffrement intelligent par blocs pour une meilleure efficacité',
  'decrypt.security.modal.vip.feature3': 'Prendre en charge le déchiffrement par lots de gros fichiers',
  'decrypt.security.modal.free.title': 'Important : Le processus de déchiffrement nécessite environ 3 fois la taille du fichier en mémoire du navigateur.',
  'decrypt.security.modal.free.feature1': 'Les utilisateurs gratuits sont limités à 4 Go par fichier',
  'decrypt.security.modal.free.feature2': 'Passez en VIP pour déchiffrer des fichiers de toute taille',
  'decrypt.security.modal.free.feature3': 'En cas de plantage du navigateur, envisagez de passer en VIP pour utiliser le déchiffrement par blocs',
  'security.diagram.plaintext.block1': 'Bloc de texte en clair 1',
  'security.diagram.plaintext.block2': 'Bloc de texte en clair 2',
  'security.diagram.ciphertext.block1': 'Bloc de texte chiffré 1',
  'security.diagram.ciphertext.block2': 'Bloc de texte chiffré 2',
  'security.diagram.key': 'Clé',
  'security.diagram.aes.encryption': 'Chiffrement AES',
  'security.diagram.xor.operation': 'Opération XOR',
  'security.diagram.iv': 'Vecteur d\'initialisation',
  'security.features.chunk.title': 'Technologie de Déchiffrement Intelligent par Blocs',
  'security.features.chunk.what': 'Qu\'est-ce que le Déchiffrement Intelligent par Blocs ?',
  'security.features.chunk.description': 'Le déchiffrement intelligent par blocs est une technologie optimisée pour les gros fichiers qui divise les fichiers en plusieurs blocs pour un traitement parallèle, avec les caractéristiques suivantes :',
  'security.features.chunk.feature1.title': 'Division Dynamique',
  'security.features.chunk.feature1.desc': 'Ajuste automatiquement la taille des blocs en fonction de la taille du fichier et de la mémoire système',
  'security.features.chunk.feature2.title': 'Traitement Parallèle',
  'security.features.chunk.feature2.desc': 'Plusieurs blocs de données sont déchiffrés simultanément, utilisant pleinement les CPU multi-cœurs',
  'security.features.chunk.feature3.title': 'Optimisation de la Mémoire',
  'security.features.chunk.feature3.desc': 'Contrôle l\'utilisation de la mémoire via le traitement en streaming pour éviter les débordements',
  'security.features.chunk.feature4.title': 'Support de Reprise',
  'security.features.chunk.feature4.desc': 'Prend en charge la reprise après interruption, améliorant la tolérance aux pannes',
  'security.features.chunk.how': 'Comment ça Fonctionne',
  'security.features.chunk.process': 'Le processus de déchiffrement intelligent par blocs comprend les étapes suivantes :',
  'security.features.chunk.step1': 'Analyse du Fichier : Calcule la taille et le nombre optimal de blocs',
  'security.features.chunk.step2': 'Division des Données : Divise le fichier chiffré en blocs de taille égale',
  'security.features.chunk.step3': 'Déchiffrement Parallèle : Plusieurs blocs sont déchiffrés simultanément',
  'security.features.chunk.step4': 'Écriture en Streaming : Les blocs déchiffrés sont écrits séquentiellement',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': 'Avantages en Performance',
  'security.features.chunk.performance.intro': 'Par rapport au déchiffrement traditionnel, le déchiffrement intelligent par blocs présente des avantages significatifs :',
  'security.features.chunk.performance.point1': 'Utilisation de la mémoire réduite jusqu\'à 90%, seulement 400Mo nécessaires pour un fichier de 4Go',
  'security.features.chunk.performance.point2': 'Vitesse de déchiffrement 3-5 fois plus rapide, utilisant les CPU multi-cœurs',
  'security.features.chunk.performance.point3': 'Prend en charge le déchiffrement de gros fichiers (>4Go), non limité par la mémoire du navigateur',
  'security.features.chunk.performance.point4': 'Processus de déchiffrement visuel avec progression et temps restant précis',
  'security.features.chunk.usage': 'Cas d\'Utilisation',
  'security.features.chunk.usage.intro': 'Le déchiffrement intelligent par blocs est particulièrement adapté aux scénarios suivants :',
  'security.features.chunk.usage.point1': 'Déchiffrement de gros fichiers (ex. vidéos, sauvegardes de base de données)',
  'security.features.chunk.usage.point2': 'Opérations de déchiffrement sur des appareils à mémoire limitée',
  'security.features.chunk.usage.point3': 'Déchiffrement par lots nécessitant un traitement parallèle',
  'security.features.chunk.usage.point4': 'Tâches de déchiffrement nécessitant un retour en temps réel',
  'security.features.chunk.diagram': 'Diagramme du Processus de Déchiffrement par Blocs',
  'security.features.aes.security': 'Caractéristiques de sécurité',
  'security.features.aes.security.intro': 'AES-256-CBC offre plusieurs garanties de sécurité :',
  'security.features.aes.security.point1': 'La clé de 256 bits offre 2^256 combinaisons possibles, impossible à casser par force brute même avec un superordinateur',
  'security.features.aes.security.point2': 'Le mode CBC garantit que des blocs de texte en clair identiques produisent des blocs chiffrés différents, augmentant la randomisation du chiffrement',
  'security.features.aes.security.point3': 'L\'utilisation du vecteur d\'initialisation (IV) garantit que même avec la même clé, chaque chiffrement produit un résultat différent',
  'security.features.aes.security.point4': 'Largement utilisé dans les domaines militaires, financiers et autres domaines nécessitant une haute sécurité',
  'security.features.aes.diagram': 'Diagramme dynamique du processus de chiffrement en mode CBC',
  'security.features.aes.why': 'Pourquoi choisir AES-256-CBC ?',
  'security.features.aes.why.intro': 'Nous avons choisi AES-256-CBC comme standard de chiffrement pour les raisons suivantes :',
  'security.features.aes.why.point1': 'Sécurité largement validée, aucune méthode d\'attaque pratique à ce jour',
  'security.features.aes.why.point2': 'Excellentes performances, chiffrement et déchiffrement rapides',
  'security.features.aes.why.point3': 'Support d\'accélération matérielle, instructions AES intégrées dans les processeurs modernes',
  'security.features.aes.why.point4': 'Large support d\'outils, implémentations matures dans tous les langages de programmation',
  'security.features.aes.what': 'Qu\'est-ce que AES-256-CBC ?',
  'security.features.aes.description': 'AES-256-CBC est une implémentation du Standard de Chiffrement Avancé (Advanced Encryption Standard), où :',
  'security.features.aes.detail.1': 'Un algorithme de chiffrement symétrique établi par l\'Institut National des Standards et de la Technologie (NIST) des États-Unis en 2001',
  'security.features.aes.detail.2': 'Utilise une longueur de clé de 256 bits, offrant le plus haut niveau de sécurité',
  'security.features.aes.detail.3': 'Le mode Chaînage des Blocs de Chiffrement (CBC) fournit une meilleure sécurité de chiffrement',
  'security.features.aes.how': 'Comment ça fonctionne',
  'security.features.aes.process': 'Le processus de chiffrement AES-256-CBC comprend les étapes suivantes :',
  'security.features.aes.step1': 'Diviser les données en clair en blocs de taille fixe (128 bits)',
  'security.features.aes.step2': 'Générer un vecteur d\'initialisation (IV) aléatoire',
  'security.features.aes.step3': 'Effectuer une opération XOR entre le bloc de texte chiffré précédent et le bloc de texte en clair actuel en utilisant le mode CBC',
  'security.features.aes.step4': 'Utiliser la clé de 256 bits pour effectuer le chiffrement AES sur le résultat du XOR',
  'security.features.aes.example': 'Exemple de processus de chiffrement :',
  'decrypt.fileList.column.name': 'Nom du fichier',
  'decrypt.fileList.column.status': 'État',
  'decrypt.fileList.column.actions': 'Actions',
  'decrypt.fileList.status.pending': 'En attente',
  'decrypt.fileList.status.decrypting': 'Déchiffrement',
  'decrypt.fileList.status.success': 'Terminé',
  'decrypt.fileList.status.error': 'Erreur',
  'decrypt.fileList.action.info': 'Info',
  'decrypt.fileList.empty': 'Aucun fichier, veuillez ajouter des fichiers à déchiffrer',
  'common.unknown': 'Inconnu',
  'common.speed': 'Vitesse',
  'common.timeSpent': 'Temps écoulé',
  'common.remaining': 'Restant',
  'decrypt.upload.dragText': 'Cliquez ou glissez des fichiers',
  'decrypt.upload.hint': 'Prend en charge les fichiers .encrypted, maximum {maxSize} par fichier',
  'decrypt.upload.button.decrypt': 'Déchiffrer la sélection',
  'decrypt.upload.button.clear': 'Vider la liste',
  'decrypt.fileInfo.modal.title': 'Informations sur le fichier',
  'decrypt.fileInfo.modal.close': 'Fermer',
  'decrypt.fileInfo.name': 'Nom du fichier',
  'decrypt.fileInfo.size': 'Taille du fichier',
  'decrypt.fileInfo.type': 'Type de fichier',
  'decrypt.fileInfo.lastModified': 'Dernière modification',
  'decrypt.fileInfo.status': 'État',
  'decrypt.fileInfo.progress': 'Progression',
  'decrypt.fileInfo.speed': 'Vitesse',
  'decrypt.fileInfo.timeRemaining': 'Temps restant',
  'decrypt.fileInfo.timeSpent': 'Temps écoulé',
  'decrypt.fileInfo.error': 'Message d\'erreur',
  'filelist.modal.rename.title': 'Renommer',
  'filelist.modal.rename.placeholder': 'Entrez le nouveau nom',
  'filelist.modal.rename.ok': 'OK',
  'filelist.modal.rename.cancel': 'Annuler',
  'page.decrypt.title': 'Outil de déchiffrement de fichiers MyStorage',
  'page.decrypt.subtitle': 'Déchiffrez vos fichiers en toute sécurité',
  'page.decrypt.helmet.title': 'Outil de déchiffrement - MyStorage',
  'page.decrypt.helmet.description': 'Outil de déchiffrement sécurisé - Déchiffrez vos fichiers localement dans le navigateur pour protéger votre confidentialité',
  'decrypt.message.invalidFile': 'Veuillez sélectionner uniquement des fichiers .encrypted',
  'decrypt.message.duplicate': 'Le fichier "{filename}" existe déjà, dédoublonnage automatique effectué',
  'decrypt.message.oversizeTitle': 'Taille de fichier dépassée',
  'decrypt.message.oversizeContent': 'Les fichiers suivants dépassent la limite gratuite (4 Go) :',
  'decrypt.message.oversizeHint': 'Passez en VIP pour déchiffrer des fichiers de toute taille',
  'decrypt.message.selectFile': 'Veuillez sélectionner des fichiers à déchiffrer',
  'decrypt.message.enterPassword': 'Veuillez entrer le mot de passe de déchiffrement',
  'decrypt.message.decryptSuccess': 'Le fichier {filename} a été enregistré',
  'decrypt.message.saveCancel': 'Enregistrement du fichier {filename} annulé',
  'decrypt.message.downloadSuccess': 'Le fichier {filename} a été enregistré dans le dossier de téléchargement',
  'decrypt.message.decryptError': 'Échec du déchiffrement du fichier {filename} : {error}',
  'decrypt.message.batchError': 'Échec du déchiffrement par lots, veuillez réessayer',
  'decrypt.password.modal.title': 'Entrez le mot de passe de déchiffrement',
  'decrypt.password.modal.placeholder': 'Entrez le mot de passe',
  'decrypt.password.modal.hint': 'Entrez le mot de passe défini lors du chiffrement, il ne sera utilisé que pour le déchiffrement local',
  'modal.newFolder.title': 'Nouveau dossier',
  'modal.newFolder.placeholder': 'Entrez le nom du dossier',
  'modal.newFolder.ok': 'Créer',
  'modal.newFolder.cancel': 'Annuler',
  'sideMenu.storageInfo.title': 'Espace de stockage',
  'sideMenu.storageInfo.usage': 'Utilisé {used} / Total {total}',
  'sideMenu.storageStats.title': 'Statistiques de stockage',
  'sideMenu.storageStats.overview': 'Aperçu',
  'sideMenu.storageStats.totalFiles': 'Total des fichiers',
  'sideMenu.storageStats.totalSize': 'Taille totale',
  'sideMenu.storageStats.fileTypes': 'Distribution des types de fichiers',
  'sideMenu.storageStats.providers': 'Fournisseurs de services',
  'common.default': 'Par défaut',
  'common.regionCode': 'Code de région',
  'common.nodeType': 'Type de nœud',
  'common.storageUsed': 'Espace utilisé',
  'common.storageAvailable': 'Espace disponible',
  'common.storageLimit': 'Capacité totale',
  'common.storageUsageDetail': 'Utilisé {used} / Total {total}',
  'common.defaultNode': 'Nœud par défaut',
  'common.confirm': 'Confirmer',
  'common.cancel': 'Annuler',
  'common.latency': 'Latence',
  'common.retry': 'Réessayer',
  'cloudDrive.nodeSelect.title': 'Sélectionner un nœud de stockage',
  'cloudDrive.nodeSelect.addNode': 'Ajouter un nœud de stockage',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Confirmer la suppression du nœud',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'Êtes-vous sûr de vouloir supprimer le nœud "{nodeName}" ? Cette action ne peut pas être annulée !',
  'cloudDrive.nodeSelect.deleteSuccess': 'Nœud supprimé avec succès',
  'cloudDrive.nodeSelect.deleteFailed': 'Échec de la suppression du nœud',
  
  // Création de nœud
  'cloudDrive.nodeCreate.title': 'Ajouter un nœud de stockage',
  'cloudDrive.nodeCreate.selectProvider': 'Sélectionner un fournisseur cloud',
  'cloudDrive.nodeCreate.nodeName': 'Nom du nœud',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Laisser vide pour utiliser le nom par défaut',
  'cloudDrive.nodeCreate.nameMaxLength': 'Le nom du nœud ne peut pas dépasser 50 caractères',
  'cloudDrive.nodeCreate.noProviders': 'Aucun fournisseur cloud disponible',
  'cloudDrive.nodeCreate.pingLatency': 'Latence {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'Test de latence en cours...',
  'cloudDrive.nodeCreate.pingFailed': 'Échec du test de latence',
  'cloudDrive.nodeCreate.pingUnavailable': 'Test de latence non disponible',
  'cloudDrive.nodeCreate.sortByLatency': 'Trier par latence',
  'cloudDrive.nodeCreate.selectRegion': 'Sélectionner une région',
  'cloudDrive.nodeCreate.selectedRegion': 'Région sélectionnée',
  'cloudDrive.nodeCreate.noRegions': 'Aucune région disponible',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Veuillez sélectionner un fournisseur cloud',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Veuillez d\'abord sélectionner un fournisseur cloud',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Veuillez d\'abord sélectionner une région',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Erreur lors du chargement de la liste des fournisseurs cloud',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Erreur lors du chargement de la liste des régions',
  'cloudDrive.nodeCreate.nodeType': 'Type de nœud',
  'cloudDrive.nodeCreate.nodeType.standard': 'Stockage standard',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Stockage basse fréquence',
  'cloudDrive.nodeCreate.nodeType.archive': 'Stockage d\'archive',
  'cloudDrive.nodeCreate.storageLimit': 'Limite de stockage',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Veuillez entrer la limite de stockage',
  'cloudDrive.nodeCreate.storageLimitMin': 'La limite de stockage ne peut pas être inférieure à 1 Go',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Entrez la limite de stockage (Go)',
  'cloudDrive.nodeCreate.success': 'Nœud de stockage créé avec succès',
  'cloudDrive.nodeCreate.failed': 'Échec de la création du nœud de stockage',
  
  // Édition de nœud
  'cloudDrive.nodeEdit.title': 'Modifier le nœud',
  'cloudDrive.nodeEdit.name': 'Nom du nœud',
  'cloudDrive.nodeEdit.nameRequired': 'Veuillez entrer le nom du nœud',
  'cloudDrive.nodeEdit.nameMaxLength': 'Le nom du nœud ne peut pas dépasser 50 caractères'
}; 